import { PulpNouveauList } from "../../../../src/data/articles/pulp-nouveau-a-tribute-to-drafting-basic-lands/PulpNouveauList.tsx";
import { MarduTriggers } from "../../../../src/data/articles/pulp-nouveau-a-tribute-to-drafting-basic-lands/sample-decks/MarduTriggers.tsx";
import * as React from 'react';
export default {
  PulpNouveauList,
  MarduTriggers,
  React
};